import { GENERAL_ACTIONS } from '../../constants/actionTypes';

const initialState = {
    token: null,
    isLoading: false,
    lightMode: false
};

const generalReducer = (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_ACTIONS.LIGHT_MODE:
            return {
                ...state,
                lightMode: !state.lightMode 
            };
        default:
            return state;
    }
};

export default generalReducer;
